module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"nav.account":"Account","nav.expand":"Expand Nav","nav.help":"Help","nav.search":"Search"}}')
  delete Component.options._Ctor
}
